import CustomViewsAPI from 'dashboard/api/customViews';

export const serializeTaskView = value =>
  JSON.stringify(value, (_key, item) => {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return item;
    return Object.fromEntries(
      Object.entries(item).sort(([left], [right]) => left.localeCompare(right))
    );
  });

export const submitTaskViewCreation = async ({
  accountId,
  userId,
  payload,
  isCurrent,
  onConfirmed = () => {},
  requestNamespace = 'task-view-request',
}) => {
  if (!accountId || !userId) throw new Error('Missing request owner');
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(serializeTaskView(payload))
  );
  const signature = Array.from(new Uint8Array(digest), byte =>
    byte.toString(16).padStart(2, '0')
  ).join('');
  if (!isCurrent()) throw new Error('Request owner changed');
  const storageKey = `${requestNamespace}:${accountId}:${userId}:${signature}`;
  const requestKey = sessionStorage.getItem(storageKey) || crypto.randomUUID();
  sessionStorage.setItem(storageKey, requestKey);
  const response = await CustomViewsAPI.create({
    ...payload,
    request_key: requestKey,
  });
  onConfirmed();
  sessionStorage.removeItem(storageKey);
  return response;
};
